import React, { useEffect, useState } from "react";
import axios from "axios";
import { Button } from "react-bootstrap";
import Swal from "sweetalert2";
import '../../Assets/Css/Adminpanel.css'


function ManageData() {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [fetchError, setFetchError] = useState(false);

    const fetchData = async () => {
        try {
            setLoading(true);
            setFetchError(false);
            const response = await axios.get("https://tharayil-power-website-be.vercel.app");
            setData(response.data);
        } catch {
            setFetchError(true);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    // Handle delete action
    const handleDelete = async (id) => {
        try {
            await axios.delete(`https://tharayil-power-website-be.vercel.app/api/data/${id}`);
            Swal.fire({
                icon: "success",
                title: "Data deleted successfully!",
                // position: "top-end",
                // toast: true,
                showConfirmButton: false,
                timer: 1500,
            });
            fetchData();
        } catch (error) {
            Swal.fire({
                icon: "error",
                title: "Failed to delete data",
            });
        }
    };

    return (
        <div>
            <h2 className="text-center fw-bold pt-5 pb-3 pt-lg-0 pb-lg-0">Manage Blog Data</h2>

            {loading && (
                <div className="text-center py-5">
                    <output className="spinner-border text-success">
                        <span className="visually-hidden">Loading...</span>
                    </output>
                </div>
            )}
            {!loading && fetchError && (
                <p className="text-center text-danger py-5">Failed to load data. Please try again.</p>
            )}
            {!loading && !fetchError && data.length === 0 && (
                <p className="text-center text-muted py-5">No blog entries found.</p>
            )}
            {!loading && data.length > 0 && (
                <div className="table-responsive py-0 px-0 py-lg-3">
                    <table className="table table-bordered border-white table-striped">
                        <thead className="thead-dark tablecolor">
                            <tr className="text-center">
                                <th className="tablecolor text-white" style={{ width: "5%" }}>No.</th>
                                <th className="tablecolor text-white" style={{ width: "15%" }}>Picture</th>
                                <th className="tablecolor text-white" style={{ width: "20%" }}>Title</th>
                                <th className="tablecolor text-white" style={{ width: "30%" }}>Description</th>
                                <th className="tablecolor text-white" style={{ width: "15%" }}>Date</th>
                                <th className="tablecolor text-white" style={{ width: "15%" }}>Action</th>
                            </tr>
                        </thead>
                        <tbody className="border-transparent border-3 align-middle">
                            {data.map((item, index) => (
                                <tr key={item._id} className="text-center w-100">
                                    <td style={{ width: "5%" }}>{index + 1}</td>
                                    <td style={{ width: "15%" }}>
                                        <img
                                            src={item.imageUrl}
                                            alt={item.title || "Blog post thumbnail"}
                                            style={{ width: "50px", height: "50px" }}
                                        />
                                    </td>
                                    <td style={{ width: "20%" }}>{item.title}</td>
                                    <td style={{ width: "30%" }}>{item.description}</td>
                                    <td style={{ width: "15%" }}>{item.date}</td>
                                    <td style={{ width: "15%" }}>
                                        <Button
                                            variant="danger"
                                            onClick={() => handleDelete(item._id)}
                                        >
                                            Delete
                                        </Button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
}

export default ManageData;
